import React, { ReactPortal } from 'react';
import ReactDOM from 'react-dom';

const ModalPortal = ({
    children,
}: {
    children: React.ReactNode;
}): ReactPortal => {
    //@ts-ignore
    return ReactDOM.createPortal(children, document.body);
};

export default ModalPortal;
